import { Stack, styled } from "@mui/material";
import dayjs from "dayjs";
import { useTranslation } from 'react-i18next';

import { Text, TextProps } from '@telegram-apps/telegram-ui';
import { toRelativeDayLabel } from "../../helpers/datetime";
import { LiquidGlassCircleButton } from "../common/LiquidGlassCircleButton";

export type QuestCalendarProps = {
    selectedDate: dayjs.Dayjs;
    isCalendarOpen: boolean;
    onToggleCalendar: () => void;
}

const BoldText = (props: TextProps) => <Text weight="1" {...props} />

const DateHeaderRow = styled(Stack)({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '14px',
    paddingRight: '14px',
    paddingTop: '12px',
    paddingBottom: '12px'
});

const RelativeDayText = styled(BoldText)({
    fontSize: '15px',
    lineHeight: '18px'
});

const DateSubText = styled(Text)({
    fontSize: '13px',
    lineHeight: '16px',
    color: 'var(--tg-theme-hint-color)'
});

export const QuestCalendar = ({ selectedDate, isCalendarOpen, onToggleCalendar }: QuestCalendarProps) => {
    const { t, i18n } = useTranslation();
    const localizedDate = selectedDate.locale(i18n.language);

    return (
        <Stack>
            <DateHeaderRow>
                <Stack>
                    <RelativeDayText>{toRelativeDayLabel(localizedDate)}</RelativeDayText>
                    <DateSubText>{localizedDate.format('dddd, D MMMM YYYY')}</DateSubText>
                </Stack>
                <LiquidGlassCircleButton
                    icon={isCalendarOpen ? 'close' : 'event_repeat'}
                    ariaLabel={t(isCalendarOpen ? 'calendar.close' : 'calendar.open')}
                    onClick={onToggleCalendar}
                    size={40}
                    iconSize={19}
                />
            </DateHeaderRow>
        </Stack>
    );
}
